//#region types
import { Amount } from "models/utilTypes/currencyType";
import { TranslationKeys } from "translations";
import { GrossSalaryAdditionalChartDataProps } from "models/propTypes/wintSalaryPropTypes";
import { CurrencyEnums } from "models/enums";
//#endregion
//#region components
import { Grid } from "@mui/material";
import ChartDataDisplay from "./chartDataDisplay";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const GrossSalaryAdditionalChartData: React.FC<GrossSalaryAdditionalChartDataProps> = (props) => {
  const { currentTotalYtd } = props;

  return (
    <Grid container direction="row" className={cssExports.salaryChartAdditionalData}>
      <Grid item>
        <ChartDataDisplay
          title={LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Salary.GrossSalaryChartAdditionalDataTitle_1
          )}
          value={new Amount(CurrencyEnums.CurrencyCode.SEK, currentTotalYtd)}
        />
      </Grid>
      {/* 
      **The code below is intentionally commented out because the prognosis part of the chart is not implemented in the
      backend yet**
      <Grid item className={cssExports.titleDivider}>
        <Divider orientation="vertical" className={cssExports.verticalDividerGrey} />
      </Grid>
      <Grid item sx={{ paddingLeft: "16px" }}>
        <ChartDataDisplay
          title={LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Salary.GrossSalaryChartAdditionalDataTitle_2
          )}
          value={new Amount(CurrencyEnums.CurrencyCode.SEK, futureTotal)}
        />
      </Grid> 
      */}
    </Grid>
  );
};

export default GrossSalaryAdditionalChartData;
